const libraries = {
  jquery: {
    name: 'jQuery',
    predefined: ['$', 'jQuery'],
  },
  lodash: {
    name: 'lodash',
    predefined: ['_'],
  },
  mustache: {
    name: 'Mustache.js',
    predefined: ['Mustache'],
  },
  bootstrap: {
    name: 'Bootstrap',
    dependsOn: ['jquery'],
  },
  p5: {
    name: 'p5.js',
    predefined: [
      'ADD',
      'ALT',
      'ARROW',
      'AUTO',
      'BACKSPACE',
      'BASELINE',
      'BEVEL',
      'BEZIER',
      'BLEND',
      'BOLD',
      'BOTTOM',
      'BURN',
      'CENTER',
      'CHORD',
      'CLOSE',
      'CONTROL',
      'CORNER',
      'CORNERS',
      'CROSS',
      'CURVE',
      'DARKEST',
      'DEGREES',
      'DELETE',
      'DIFFERENCE',
      'DODGE',
      'DOWN_ARROW',
      'ENTER',
      'ESCAPE',
      'EXCLUSION',
      'HALF_PI',
      'HAND',
      'HARD_LIGHT',
      'HSB',
      'ITALIC',
      'LEFT',
      'LEFT_ARROW',
      'LIGHTEST',
      'LINEAR',
      'LINES',
      'MITER',
      'MOVE',
      'MULTIPLY',
      'NORMAL',
      'OPEN',
      'OPTION',
      'OVERLAY',
      'PI',
      'PIE',
      'POINTS',
      'PROJECT',
      'QUADRATIC',
      'QUADS',
      'QUAD_STRIP',
      'QUARTER_PI',
      'RADIANS',
      'RADIUS',
      'REPLACE',
      'RETURN',
      'RGB',
      'RIGHT',
      'RIGHT_ARROW',
      'ROUND',
      'SCREEN',
      'SHIFT',
      'SOFT_LIGHT',
      'SQUARE',
      'TAB',
      'TAU',
      'TEXT',
      'TOP',
      'TRIANGLES',
      'TRIANGLE_FAN',
      'TRIANGLE_STRIP',
      'TWO_PI',
      'UP_ARROW',
      'WAIT',
      'abs',
      'acos',
      'alpha',
      'angleMode',
      'append',
      'applyMatrix',
      'arc',
      'arrayCopy',
      'asin',
      'atan',
      'atan2',
      'background',
      'beginContour',
      'beginRaw',
      'beginRecord',
      'beginShape',
      'bezier',
      'bezierDetail',
      'bezierPoint',
      'bezierTangent',
      'bezierVertex',
      'blend',
      'blendMode',
      'blue',
      'brightness',
      'ceil',
      'clear',
      'color',
      'colorMode',
      'concat',
      'constrain',
      'copy',
      'cos',
      'createCanvas',
      'createGraphics',
      'createImage',
      'createInput',
      'createOutput',
      'createReader',
      'createVector',
      'createWriter',
      'cursor',
      'curve',
      'curveDetail',
      'curvePoint',
      'curveTangent',
      'curveTightness',
      'curveVertex',
      'day',
      'degrees',
      'devicePixelScaling',
      'displayHeight',
      'displayWidth',
      'dist',
      'downloadFile',
      'draw',
      'ellipse',
      'ellipseMode',
      'endContour',
      'endRaw',
      'endRecord',
      'endShape',
      'exit',
      'exp',
      'fill',
      'filter',
      'float',
      'floor',
      'focused',
      'frameCount',
      'frameRate',
      'fullscreen',
      'get',
      'getFrameRate',
      'getURL',
      'getURLParams',
      'getURLPath',
      'green',
      'height',
      'hour',
      'httpDo',
      'httpGet',
      'httpPost',
      'hue',
      'image',
      'imageMode',
      'int',
      'isKeyPressed',
      'isMousePressed',
      'join',
      'key',
      'keyCode',
      'keyIsDown',
      'keyIsPressed',
      'lerp',
      'lerpColor',
      'line',
      'loadBytes',
      'loadImage',
      'loadJSON',
      'loadPixels',
      'loadStrings',
      'loadTable',
      'loadXML',
      'log',
      'loop',
      'mag',
      'map',
      'match',
      'matchAll',
      'max',
      'millis',
      'min',
      'minute',
      'month',
      'mouseButton',
      'mouseIsPressed',
      'mouseX',
      'mouseY',
      'nf',
      'nfc',
      'nfp',
      'nfs',
      'noCanvas',
      'noCursor',
      'noFill',
      'noLoop',
      'noSmooth',
      'noStroke',
      'noTint',
      'noise',
      'noiseDetail',
      'noiseSeed',
      'norm',
      'onblur',
      'onclick',
      'onkeydown',
      'onkeypress',
      'onkeyup',
      'onmousedown',
      'onmousemove',
      'onmouseup',
      'onmousewheel',
      'onresize',
      'ontouchend',
      'ontouchmove',
      'ontouchstart',
      'parseXML',
      'pixels',
      'pmouseX',
      'pmouseY',
      'point',
      'pop',
      'popMatrix',
      'popStyle',
      'pow',
      'print',
      'printMatrix',
      'println',
      'ptouchX',
      'ptouchY',
      'push',
      'pushMatrix',
      'pushStyle',
      'pwinMouseX',
      'pwinMouseY',
      'quad',
      'quadraticVertex',
      'radians',
      'random',
      'randomGaussian',
      'randomSeed',
      'rect',
      'rectMode',
      'red',
      'redraw',
      'registerMethod',
      'registerPreloadMethod',
      'resetMatrix',
      'resizeCanvas',
      'reverse',
      'rotate',
      'rotateX',
      'rotateY',
      'round',
      'saturation',
      'save',
      'saveBytes',
      'saveCanvas',
      'saveFrames',
      'saveJSON',
      'saveJSONArray',
      'saveJSONObject',
      'saveStream',
      'saveStrings',
      'saveTable',
      'saveXML',
      'scale',
      'second',
      'selectFolder',
      'selectInput',
      'selectOutput',
      'set',
      'setFrameRate',
      'setup',
      'shearX',
      'shearY',
      'shorten',
      'sin',
      'size',
      'smooth',
      'sort',
      'splice',
      'split',
      'splitTokens',
      'sq',
      'sqrt',
      'stroke',
      'strokeCap',
      'strokeJoin',
      'strokeWeight',
      'subset',
      'tan',
      'text',
      'textAlign',
      'textAscent',
      'textDescent',
      'textFont',
      'textLeading',
      'textSize',
      'textStyle',
      'textWidth',
      'tint',
      'touchIsDown',
      'touchX',
      'touchY',
      'touches',
      'translate',
      'triangle',
      'trim',
      'updatePixels',
      'vertex',
      'width',
      'winMouseX',
      'winMouseY',
      'windowHeight',
      'windowWidth',
      'writeFile',
      'year',
    ],
  },
};

export default libraries;
